import { definePlayerFeature } from "../../feature.js";
import { isRemotePlaybackConnected, requestRemotePlayback } from "../../presentation/remote-playback.js";
import { exitFullscreen, isFullscreen } from "../../presentation/fullscreen.js";
import { isWebKitAirPlayCapable, listen } from "@videojs/utils/dom";
import { isMediaRemotePlaybackCapable } from "@videojs/media";
//#region src/dom/store/features/remote-playback.ts
const remotePlaybackFeature = definePlayerFeature({
	name: "remotePlayback",
	state: ({ target }) => ({
		remotePlaybackState: "disconnected",
		remotePlaybackAvailability: "unsupported",
		async toggleRemotePlayback() {
			const { media, container } = target();
			if (isRemotePlaybackConnected(media)) return requestRemotePlayback(media);
			if (isFullscreen(container, media)) await exitFullscreen(media);
			return await requestRemotePlayback(media);
		}
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaRemotePlaybackCapable(media)) return;
		if (isWebKitAirPlayCapable(media)) {
			const syncConnection = () => {
				set({ remotePlaybackState: media.webkitCurrentPlaybackTargetIsWireless ? "connected" : "disconnected" });
			};
			const syncAvailability = (event) => {
				const { availability } = event;
				set({ remotePlaybackAvailability: availability === "available" ? "available" : "unavailable" });
			};
			listen(media, "webkitplaybacktargetavailabilitychanged", syncAvailability, { signal });
			listen(media, "webkitcurrentplaybacktargetiswirelesschanged", syncConnection, { signal });
			syncConnection();
			return;
		}
		const syncState = () => set({ remotePlaybackState: media.remote.state });
		syncState();
		listen(media.remote, "connect", syncState, { signal });
		listen(media.remote, "connecting", syncState, { signal });
		listen(media.remote, "disconnect", syncState, { signal });
		media.remote.watchAvailability((available) => {
			set({ remotePlaybackAvailability: available ? "available" : "unavailable" });
		}).catch(() => {
			set({ remotePlaybackAvailability: "unsupported" });
		});
		signal.addEventListener("abort", () => {
			media.remote?.cancelWatchAvailability?.().catch(() => {});
		});
	}
});
//#endregion
export { remotePlaybackFeature };

//# sourceMappingURL=remote-playback.js.map